module.exports = {
    "crude": {
        "search": "Cercare",
        "actions": "Azioni",
        "nextPage": "Pagina successiva",
        "lastPage": "Pagina precedente",
        "back": "Indietro",
        "empty": "vuoto",
        "edit": "modificare",
        "create": "creare",
        "data": "documentazione",
        "view": "spettacolo",
        "delete": "Eliminare",
        "save": "Salva",
        "cancel": "Annulla",
        "noContent": "Nessuna voce disponibile ",
        "resetFilter": "Reimposta i filtri e visualizza più contenuti!",
        "createOwnTextField": "Crea il tuo campo di testo",
        "textFieldName": "etichetta del campo di testo",
        "textFieldValue": "Contenuti",
        "insertTextFieldLabel": "Inserisci il nome del campo di testo!",
        "deleteTextField": "Elimina campo di testo",
        "success": "Il salvataggio è riuscito",
        "invalidDataFields": "I seguenti campi dati non sono validi:  ",
        "entries": "inserimenti",
        "entry": "iscrizione",
        "tabDetail": "dettagli",
        "entity": "entità",
        "of": "da",
        "uploadNewFile": "Caricare un file",
        "upload": "caricamento",
        "confirm": "OK",
        "deleteFileQuestion": "Vuoi davvero eliminare questo file? ",
        "deleteFileQuestionTitle": "Pericolo!",
        "deleteEntityQuestion": "Vuoi davvero eliminare questa entità? ",
        "deleteEntityQuestionTitle": "Pericolo!",
        "errorLargeFileUpload": "Il file selezionato è troppo grande!",
        "useCroppedImage": "Usa il ritaglio",
        "useOriginalImage": "Usa l'immagine originale",
        "available": "disponibile",
        "searchColumn": "trova colonna",
        "manageColumns": "Gestisci colonne",
        "hideColumn": "nascondi colonna",
        "pinToRight": "Blocca la colonna a destra",
        "pinToLeft": "Colonna dei puntini a sinistra",
        "sortAsc": "Ordine crescente",
        "sortDesc": "Ordine decrescente",
        "hideAll": "nascondi tutto",
        "showAll": "Mostra tutto",
        "preview": "anteprima",
        "title": "titolo",
        "description": "Descrizione",
        "tooltip": "descrizione comando",
        "sort": "ordina per",
        "settings": "Impostazioni",
        "incomingReference": "riferimento",
        "language": "Lingua",
        "deleteTabQuestionTitle": "Pericolo!",
        "deleteTabQuestion": "Vuoi davvero eliminare questa scheda? ",
        "deleteElementQuestionTitle": "Pericolo!",
        "deleteElementQuestion": "Vuoi davvero eliminare questo elemento? ",
        "configurationEditorDescriptionStringLayout": "In questa colonna è possibile selezionare tre varianti per l'immissione del testo:",
        "configurationEditorDescriptionEnumLayout": "È possibile selezionare due varianti per la selezione degli elementi in questa colonna:",
        "configurationEditorDescriptionBooleanLayout": "È possibile selezionare due varianti per la selezione degli elementi in questa colonna:",
        "configurationEditorDescriptionForeignEntityLayout": "È possibile selezionare due varianti per la selezione degli elementi in questa colonna:",
        "stringLayoutsingleline": "linea singola",
        "stringLayoutmultiline": "multilinea",
        "stringLayouteditor": "Editor di testo ricco",
        "enumLayoutradio": "pulsante di opzione",
        "enumLayoutdropdown": "cadere in picchiata",
        "booleanLayoutcheckbox": "casella di controllo",
        "booleanLayoutswitch": "interruttori",
        "foreignEntityLayoutpopUp": "apparire",
        "foreignEntityLayoutautocomplete": "cadere in picchiata",
        "foreignEntityLayoutlist": "elenco",
        "formatTooltipbold": "Grasso",
        "formatTooltipitalic": "corsivo",
        "formatTooltipunderline": "sottolineato",
        "formatTooltipstrike": "Barrato",
        "formatTooltipclean": "formattazione chiara",
        "formatTooltipcodeBlock": "codice",
        "formatTooltipblockquote": "Citazione",
        "formatTooltipcolor": "colore del carattere",
        "formatTooltipbackground": "colore di sfondo",
        "formatTooltipfont": "font",
        "formatTooltipalign": "allineamento",
        "formatTooltipheader": "dimensione del font",
        "formatTooltipsuper": "Apice",
        "formatTooltipsub": "pedice",
        "formatTooltipordered": "Lista ordinata",
        "formatTooltipbullet": "Enumerazione",
        "true": "SÌ",
        "false": "NO",
        "selectEntity": "seleziona entità",
        "filter": "filtro",
        "useFilter": "Applica filtri",
        "defaultFilter": "reimpostare il filtro",
        "expand": "espandere",
        "hide": "nascondere",
        "minimumSelectionError": "È necessario selezionare almeno {{min}} voci.",
        "maximumSelectionError": "È possibile selezionare un massimo di {{max}} voci."
    }
}
;